











import { Vue, Component } from 'vue-property-decorator';
import { isMobile } from '@/common/ts/common';

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
]);

@Component
export default class RouterViewHolder extends Vue {
  beforeRouteEnter(to: any, from: any, next: any) {
    const param = to.params.roomNumber || to.params.videoNumber;
    let prefixUrl = `${location.origin}/cq-expo-hotpot-live-pc/`;
    if (location.host === 'dev.cqcb.com') {
      prefixUrl = `${location.origin}/cq-expo-hotpot-live-pc/`;
    } else if (location.host === 'activity.cqcb.com') {
      prefixUrl = `${location.origin}/shangyou_activity/cq-expo-hotpot-live-pc/`;
    }
    let pcUrl = '';
    if (to.name === 'LiveRoom') {
      pcUrl = `${prefixUrl}live-room/${param}`;
    } else if (to.name === 'VideoList') {
      pcUrl = `${prefixUrl}videos/${param}`;
    }
    if (!isMobile() && (to.name === 'LiveRoom' || to.name === 'VideoList')) {
      console.log('is pc platform');
      location.href = pcUrl;
    } else {
      next();
    }
  }
  onNavTo() {
    location.href = 'http://www.3dqiye.com/anli/vre/cq/hg1/?startscene=1';
  }
}
